import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(chrome)/continents/page.tsx")